/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { DeleteAdminCategoryDataType } from './AdminDatasetsCategoriesPage.types';

export const deleteAdminCategoryInitialValues: DeleteAdminCategoryDataType = {
  id: '',
  name: '',
  isModalOpened: false,
};
